// extracted by mini-css-extract-plugin
export default {"content":"SpinnerComponent_content__+AB2b","spinner":"SpinnerComponent_spinner__iPkOZ"};